import { reducer as getAllAudit } from './getAllAudit'
import { reducer as getAuditById } from './getAuditById'
import { reducer as getAuditCreatedBy } from './getAuditCreatedBy'
import { reducer as selectedAudit } from './selectedAudit'

export default {
  getAllAudit,
  getAuditById,
  getAuditCreatedBy,
  selectedAudit
}



// WEBPACK FOOTER //
// ./src/store/audit/index.js